import { render } from "./MediaList.vue?vue&type=template&id=bb03117c"
import script from "./MediaList.vue?vue&type=script&lang=js"
export * from "./MediaList.vue?vue&type=script&lang=js"

import exportComponent from "/Users/theimer/Developer/laravel/nova-medialibrary-field/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__